<app-painel-lateral
    [tituloPainel]="'Situação Mensal'"
    [descricaoPainel]="'Situação atual, sexo, movimento e cancelamentos do mês e endereço por tipo de inscrição.'"
    [iconePainel]="'pi pi-calendar'"
    [filtrosTemplate]="filtros"
    [conteudoTemplate]="conteudo"
>
</app-painel-lateral>

<ng-template #filtros>
    <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">UF do estado</span>
        <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
    </label>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">Mês</span>
        <p-select [options]="meses" [(ngModel)]="mesSelecionado" optionLabel="label" optionValue="value" appendTo="body"></p-select>
    </label>
    <label class="mapa-filtro" for="situacao-mensal-ano">
        <span class="mapa-filtro-label">Ano</span>
        <input id="situacao-mensal-ano" pInputText class="ano-input" type="number" min="1900" [max]="anoAtual + 1" [(ngModel)]="anoSelecionado" />
    </label>
    <p-button label="Aplicar" icon="pi pi-search" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    @if (detalheAtivo) {
        <app-detalhamento-pendencias
            [indicador]="obterIndicadorDetalhe()"
            [linhas]="linhasDetalhe"
            [first]="firstDetalhe"
            [rows]="rowsDetalhe"
            [totalRecords]="totalDetalhe"
            [carregando]="carregandoDetalhe"
            [rotuloVoltar]="'Voltar à situação mensal'"
            [colunaIdentificador]="'CRM'"
            [colunaNome]="'NOME'"
            [voltarNoCard]="true"
            [permitirVisualizacaoCard]="true"
            (voltar)="voltarParaCards()"
            (paginaAlterada)="onPageChangeDetalhe($event)"
        >
        </app-detalhamento-pendencias>
    } @else {
        <div class="card-entrada card-entrada-1 resumo-card">
            <app-card-content [border]="false" [title]="ufAplicadaLabel" [subtitle]="resumoSubtitulo" icon="pi pi-calendar">
                @if (carregando) {
                    <p-skeleton width="100%" height="4rem" />
                } @else {
                    <div class="kpis">
                        <div class="kpi">
                            <span class="kpi-valor">{{ totalInscritos | number }}</span>
                            <span class="kpi-rotulo">inscritos</span>
                        </div>
                        <div class="kpi">
                            <span class="kpi-valor">{{ totalAtivos | number }}</span>
                            <span class="kpi-rotulo">ativos · {{ percentualAtivos | number: '1.0-0' }}%</span>
                        </div>
                        <div class="kpi">
                            <span class="kpi-valor kpi-pos">+{{ novasInscricoes | number }}</span>
                            <span class="kpi-rotulo">novas no mês</span>
                        </div>
                        <div class="kpi">
                            <span class="kpi-valor kpi-neg">−{{ baixasMes | number }}</span>
                            <span class="kpi-rotulo">baixas no mês</span>
                        </div>
                        <div class="kpi kpi-destaque">
                            <span class="kpi-valor" [ngClass]="saldoMes >= 0 ? 'kpi-pos' : 'kpi-neg'">{{ saldoMes >= 0 ? '+' : '−' }}{{ saldoMesAbs | number }}</span>
                            <span class="kpi-rotulo">saldo do mês</span>
                        </div>
                    </div>
                }
            </app-card-content>
        </div>

        <div class="situacao-mensal-grid">
            <ng-container *ngTemplateOutlet="bloco; context: { titulo: 'Situação atual · posição de hoje', icone: 'pi-verified', linhas: situacaoLinhas, mostrarPct: true, drillCard: 'situacao' }"></ng-container>
            <ng-container *ngTemplateOutlet="bloco; context: { titulo: 'Sexo (ativos/suspensos) · posição de hoje', icone: 'pi-users', linhas: sexoLinhas, mostrarPct: true }"></ng-container>
            <ng-container *ngTemplateOutlet="bloco; context: { titulo: 'Movimento · ' + periodoCurto, icone: 'pi-sync', linhas: movimentoLinhas, mostrarPct: false, drillCard: 'movimento' }"></ng-container>
            <ng-container *ngTemplateOutlet="bloco; context: { titulo: 'Cancelamentos · ' + periodoCurto, icone: 'pi-times-circle', linhas: cancelamentosLinhas, mostrarPct: false }"></ng-container>
        </div>

        <div class="card-entrada card-entrada-1 bloco-endereco">
            <app-card-content [border]="false" [title]="'Endereço × tipo de inscrição'" [subtitle]="'Posição de hoje. Considera as inscrições principal, secundária e provisória.'" icon="pi pi-map-marker">
                <p-table [value]="enderecoTipoItens" [loading]="carregando" styleClass="p-datatable-sm w-full" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Faixa</th>
                            <th class="num">Primária</th>
                            <th class="num">Secundária</th>
                            <th class="num">Provisória</th>
                            <th class="num">Total</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-l>
                        <tr>
                            <td>{{ l.descricao || l.faixaEndereco }}</td>
                            <td class="num">{{ l.primaria ?? 0 | number }}</td>
                            <td class="num">{{ l.secundaria ?? 0 | number }}</td>
                            <td class="num">{{ l.provisoria ?? 0 | number }}</td>
                            <td class="num">{{ l.total ?? 0 | number }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        @if (enderecoTipoItens.length) {
                            <tr class="linha-total">
                                <td>Total</td>
                                <td class="num">{{ totaisEndereco.primaria ?? 0 | number }}</td>
                                <td class="num">{{ totaisEndereco.secundaria ?? 0 | number }}</td>
                                <td class="num">{{ totaisEndereco.provisoria ?? 0 | number }}</td>
                                <td class="num">{{ totaisEndereco.total ?? 0 | number }}</td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5">Sem dados para os filtros selecionados.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        </div>
    }
</ng-template>

<ng-template #bloco let-titulo="titulo" let-icone="icone" let-linhas="linhas" let-mostrarPct="mostrarPct" let-drillCard="drillCard">
    <div class="card-entrada card-entrada-1">
        <app-card-content [border]="false" [title]="titulo" [icon]="'pi ' + icone">
            @if (carregando) {
                <p-skeleton width="100%" height="8rem" />
            } @else if (linhas.length) {
                <div class="linhas">
                    @for (l of linhas; track l.descricao) {
                        <div
                            class="linha"
                            [class.linha-dominante]="l.dominante"
                            [style.cursor]="drillCard && l.codigo && l.total > 0 ? 'pointer' : null"
                            [attr.role]="drillCard && l.codigo && l.total > 0 ? 'button' : null"
                            [attr.tabindex]="drillCard && l.codigo && l.total > 0 ? 0 : null"
                            [attr.title]="drillCard && l.codigo && l.total > 0 ? 'Ver médicos' : null"
                            (click)="drillCard ? verDetalhe(drillCard, l) : null"
                        >
                            <div class="linha-topo">
                                <span class="linha-desc">{{ l.descricao }}</span>
                                <span class="linha-valores">
                                    <span class="linha-num">{{ l.total | number }}</span>
                                    @if (mostrarPct) {
                                        <span class="linha-pct">{{ l.share | number: '1.0-0' }}%</span>
                                    }
                                </span>
                            </div>
                            <div class="linha-barra"><div class="linha-barra-fill" [style.width.%]="l.barra"></div></div>
                        </div>
                    }
                </div>
            } @else {
                <div class="bloco-sem-dados">Sem dados.</div>
            }
        </app-card-content>
    </div>
</ng-template>
